import React from "react";
import { Eye, EyeOff, Copy, Trash2, FileText } from "lucide-react";
import { processColors } from "./constants";

const TemplateCard = ({
  template,
  onCopy,
  onDelete,
  onAssignANR,
  expandedTemplates,
  toggleExpand,
}) => {
  const isExpanded = expandedTemplates[template._id];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      {/* Template Header */}
      <div className="p-4">
        <div className="flex items-start justify-between">
          <h3 className="font-semibold text-gray-900 truncate flex-1">
            {template.name}
          </h3>
          <div className="flex items-center gap-1 ml-2">
            {/* Copy Button */}
            <button
              onClick={() => onCopy(template)}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              title="Template kopieren"
            >
              <Copy className="w-4 h-4 text-gray-500" />
            </button>
            {/* Delete Button */}
            <button
              onClick={() => onDelete(template)}
              className="p-2 hover:bg-red-50 rounded-lg transition-colors"
              title="Template löschen"
            >
              <Trash2 className="w-4 h-4 text-red-500" />
            </button>
            {/* Toggle Processes View */}
            <button
              onClick={() => toggleExpand(template._id)}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              title={isExpanded ? "Prozesse ausblenden" : "Prozesse anzeigen"}
            >
              {isExpanded ? (
                <EyeOff className="w-4 h-4 text-gray-500" />
              ) : (
                <Eye className="w-4 h-4 text-gray-500" />
              )}
            </button>
          </div>
        </div>

        {/* Assigned ANR */}
        <div className="mt-2">
          {template.assignedANR ? (
            <div className="text-sm">
              <span className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs font-medium">
                {template.assignedANR.anr}
              </span>
              <p className="text-gray-500 text-xs mt-1 truncate">
                {template.assignedANR.auftragsbezeichnung}
              </p>
            </div>
          ) : (
            <p className="text-sm text-gray-400">Keine ANR zugewiesen</p>
          )}
        </div>

        {/* Assign ANR Button */}
        <button
          onClick={() => onAssignANR(template)}
          className="mt-3 w-full flex items-center justify-center gap-2 px-3 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors"
        >
          <FileText className="w-4 h-4" />
          ANR ZUWEISEN
        </button>
      </div>

      {/* Expanded Processes */}
      {isExpanded && template.processes && template.processes.length > 0 && (
        <div className="border-t bg-gray-50 p-4">
          <h4 className="text-sm font-medium text-gray-700 mb-3">
            Prozesse ({template.processes.length})
          </h4>
          <div className="space-y-2 max-h-[300px] overflow-y-auto">
            {template.processes.map((process, index) => (
              <div
                key={process._id || process.id || index}
                className="flex items-center gap-2 p-2 bg-white rounded border"
              >
                <div
                  className="w-3 h-3 rounded-full flex-shrink-0"
                  style={{
                    backgroundColor:
                      processColors[process.id] || processColors[1],
                  }}
                />
                <span className="text-sm text-gray-700 truncate flex-1">
                  {process.label}
                </span>
                <span className="text-xs text-gray-400 flex-shrink-0">
                  {process.hours ? `${process.hours * 60}M` : ""}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TemplateCard;
